import { getSkillChatURL } from '#pplx/frontend/apps/ask/skills/utils/getSkillChatURL.js';
import { useRouter } from '#pplx/frontend/router/provider.js';
import { useCallback, useMemo } from 'react';
export function useUrlSkillChatExecutors() {
    const router = useRouter();
    const execute = useCallback((action) => {
        router.push(getSkillChatURL(action));
    }, [router]);
    return useMemo(() => ({ executeTryInChat: execute, executeEditInChat: execute }), [execute]);
}
//# sourceMappingURL=useUrlSkillChatExecutors.js.map